"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("@angi/icons/design-system-icons/ui-icons/32");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));

var _snowplowReact = require("@angi/snowplow-react");

require("./restrictedAccess.scss");

var _restrictedAccessUtills = require("./restrictedAccessUtills");

var LegacyRestrictedAccess = function LegacyRestrictedAccess(_ref) {
  var spId = _ref.spId,
      title = _ref.title,
      subtitle = _ref.subtitle,
      buttonText = _ref.buttonText,
      iconClassName = _ref.iconClassName,
      iconWrapperClassName = _ref.iconWrapperClassName,
      onClick = _ref.onClick,
      className = _ref.className,
      variant = _ref.variant,
      customIcon = _ref.customIcon,
      showButton = _ref.showButton;
  var isRestrictedAccess = (0, _restrictedAccessUtills.getIsRestrictedAccess)(variant);
  var computedTitle = (0, _restrictedAccessUtills.getRestrictedAccessTitle)(title, isRestrictedAccess);
  var computedSubtitle = (0, _restrictedAccessUtills.getRestrictedAccessSubtitle)(subtitle, isRestrictedAccess);
  var computedButtonText = (0, _restrictedAccessUtills.getRestrictedAccessButtonText)(buttonText);

  var handleButtonClick = function handleButtonClick() {
    if (onClick) {
      onClick();
    } else {
      window.location.href = (0, _restrictedAccessUtills.getRestrictedAccessButtonHref)(isRestrictedAccess, spId);
    }
  };

  var Icon = customIcon || /*#__PURE__*/_react["default"].createElement(_.AlertIcon32, {
    className: "restricted-access-alert-icon ".concat(iconClassName).trim()
  });

  var snowplowParams = {
    pageName: "leads sp : ".concat(isRestrictedAccess ? 'restricted access' : 'no access')
  };
  (0, _snowplowReact.useEnhancedPageView)(snowplowParams);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "restricted-access-container ".concat(className).trim()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "restricted-access-root"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "restricted-access-icon-wrapper ".concat(iconWrapperClassName).trim()
  }, Icon), /*#__PURE__*/_react["default"].createElement("span", {
    className: "restricted-access-title"
  }, computedTitle), computedSubtitle && /*#__PURE__*/_react["default"].createElement("span", {
    className: "restricted-access-subtitle"
  }, computedSubtitle), showButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    "data-snowplow-leads-service-provider-id": spId,
    className: "restricted-access-submit-button",
    bsStyle: "primary-office",
    onClick: handleButtonClick
  }, computedButtonText)));
};

LegacyRestrictedAccess.defaultProps = {
  title: '',
  subtitle: '',
  buttonText: '',
  iconClassName: '',
  iconWrapperClassName: '',
  onClick: null,
  className: '',
  variant: 'restricted',
  customIcon: undefined,
  showButton: true
};
var _default = LegacyRestrictedAccess;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/restrictedAccess/legacyRestrictredAccess.js
// module id = 2345
// module chunks = 25